<template>
  <Select2 :value="selected"
           :options="ajaxOptions"
           :settings="{allowClear:false, theme:'bootstrap4', placeholder: 'Vyberte', ajax: ajax }"
           @change="updateValue($event)"
           id="city-select2"
  />

</template>

<script>
import Select2 from 'v-select2-component';

export default {
  name: "CitySelect",
  components: {Select2},
  props: {
    district: {
      type: [String, Number]
    },
    error: {
      type: Boolean
    },
    selected: {
      type: [Number, String],
      required: false
    }
  },
  data: function () {
    return {
      ajaxOptions: [],
      ajax: {
        url: '/cadastre/cadastre/cities',
        dataType: 'json',
        delay: 250,
        data:(params) => (
           this.createAjaxObj(params.term)
        ),
        processResults: function (data) {
          return {
            results: data.map(x => {
              return {id: x.id, text: x.name}
            })
          };
        }
      }
    }
  },
  methods: {
    updateValue: function (value) {
      this.$emit('update:value', value);
    },
    createAjaxObj(search) {
      let ajaxObject = {
        obec_nazev: search,
        okres_kod: this.district ?? null,
      };
      for (const key in ajaxObject) {
        if (ajaxObject[key] === null || ajaxObject[key] === undefined) {
          delete ajaxObject[key];
        }
      }

      return ajaxObject;
    },
    loadData() {
      axios.get('/cadastre/cadastre/cities', {params: {obec_kod: this.selected}}).then(response => {
        this.ajaxOptions = $.map(response.data, function (city) {
          city.text = city.text || city.name; // replace name with the property used for the text
          return city;
        });
      });
    }
  },
  mounted() {
    this.loadData();
  },
  watch: {
    error() {
      if (this.error) {
        $('#city-select2').addClass('is-invalid');
      }
    },
    ajaxOptionSelected() {
      $('#city-select2').removeClass('is-invalid');
    },
    selected() {
      this.loadData();
    }
  }
}
</script>

<style scoped>

</style>

